import { RowTurnCompanyDto } from "@/dtos";
import { Company, TurnCompany } from "@/entities";

export const formatRowTurnCompanyDto = (turnCompany: TurnCompany, company: Company): RowTurnCompanyDto => {
    const row: RowTurnCompanyDto = {
        ...turnCompany,
        active: (turnCompany.is_active) ? 'Activo' : 'Inactivo',
        company: company.name,
        company_id: company.id
    }
    
    return row;
}